// extracted by mini-css-extract-plugin
export var button = "add-meal-modal-module--button--DWB5y";
export var form = "add-meal-modal-module--form--Q7uWB";
export var globalError = "add-meal-modal-module--global-error--YoSyr";
export var inputFile = "add-meal-modal-module--input-file--I0CQR";
export var inputFileInfo = "add-meal-modal-module--input-file-info--daL-b";
export var inputRow = "add-meal-modal-module--input-row--COK2i";
export var modal = "add-meal-modal-module--modal--3kiOx";
export var separator = "add-meal-modal-module--separator--q-DoS";